import { render, staticRenderFns } from "./MarketingSearch.vue?vue&type=template&id=585f1d97&scoped=true"
import script from "./MarketingSearch.vue?vue&type=script&lang=js"
export * from "./MarketingSearch.vue?vue&type=script&lang=js"
import style0 from "./MarketingSearch.vue?vue&type=style&index=0&id=585f1d97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585f1d97",
  null
  
)

export default component.exports